<div class="ef-page">

  <div class="ef-header">
    <div class="ef-header__icon"><mat-icon>account_balance</mat-icon></div>
    <div>
      <h1 class="ef-header__title">{{ uid ? 'Editar subvención' : 'Nueva subvención' }}</h1>
      <p class="ef-header__sub">{{ uid ? 'Modifica los datos de la subvención' : 'Registra una subvención concedida y su cobro' }}</p>
    </div>

    <div class="pf-header-actions">
      <button mat-stroked-button type="button" class="pf-btn-cancel" (click)="onCancel()" [disabled]="isSaving">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <button mat-flat-button type="button" class="ef-btn-save" (click)="onSave()" [disabled]="isSaving || isLoading || loadingFile">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </div>

  <div class="ef-body" *ngIf="!isLoading">
    <form [formGroup]="form" class="gf-form">

      <div class="pf-side-by-side">
        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Datos de la subvención</h6>
            </div>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo de subvención</mat-label>
              <mat-select formControlName="subventionTypeUid" (selectionChange)="onTypeChange()">
                <mat-option *ngFor="let type of subventionTypes" [value]="type.id">{{ type.display }}</mat-option>
              </mat-select>
              <mat-error>Tipo de subvención es obligatorio</mat-error>
            </mat-form-field>

            <app-autocomplete [control]="form.get('provider')" [config]="{
                label: 'Administración / Organismo',
                placeholder: 'Buscar o escribir organismo...',
                options: contacts,
                allowCustomValues: true
              }">
            </app-autocomplete>

            <app-date [control]="form.get('date')" [config]="{ label: 'Fecha de concesión' }"></app-date>

            <app-textarea [control]="form.get('elementDescription')" [config]="{ label: 'Descripción de la subvención', placeholder: 'Finalidad, convocatoria, expediente…', rows: 3 }"></app-textarea>

            <app-autocomplete *ngIf="isProjectEnable" [control]="form.get('projectUid')" [config]="{
                label: 'Proyecto',
                placeholder: 'Seleccionar proyecto...',
                options: projects
              }">
            </app-autocomplete>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Cobro y contabilidad</h6>
            </div>

            <div class="pf-grid-2">
              <app-field [control]="form.get('totalWithoutTax')" [config]="{ label: 'Total recibido (€)', type: 'number' }"></app-field>
              <app-date [control]="form.get('paided')" [config]="{ label: 'Fecha de cobro' }"></app-date>
            </div>

            <app-autocomplete [control]="form.get('bankAccountUid')" [config]="{
                label: 'Cuenta bancaria',
                placeholder: 'Seleccionar cuenta...',
                options: bankAccounts, autoSelectSingle: true
              }">
            </app-autocomplete>

            <app-autocomplete [control]="form.get('entranceAccount')" [config]="{
                label: 'Cuenta contable de ingreso',
                placeholder: 'Seleccionar cuenta...',
                options: accounts
              }">
            </app-autocomplete>

            <app-autocomplete [control]="form.get('investmentUid')" [config]="{
                label: 'Inversión',
                placeholder: 'Seleccionar inversión...',
                options: investments, autoSelectSingle: true
              }">
            </app-autocomplete>

            <p class="gf-hint" *ngIf="isExplotacion">
              <mat-icon>info</mat-icon>
              <span>Las subvenciones de explotación no se vinculan a una inversión.</span>
            </p>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-card appearance="outlined" class="tf-card" *appCompanyMode="'nonprofit'">
        <mat-card-content>
          <div class="tf-section-header">
            <h6 class="tf-section-title">Asociaciones/Fundaciones</h6>
          </div>

          <mat-checkbox formControlName="isPrimaryFunder">Financiador principal</mat-checkbox>

          <app-color-swatch-picker [control]="form.get('color')" [config]="{ label: 'Color de categorización' }"></app-color-swatch-picker>

          <div class="gf-budget-table" formArrayName="categoryBudgets">
            <div class="gf-budget-row gf-budget-row--head">
              <span>Categoría</span>
              <span>Presupuesto</span>
              <ng-container *ngIf="uid">
                <span>Justificado</span>
                <span>%</span>
              </ng-container>
            </div>
            <div class="gf-budget-row" *ngFor="let row of categoryBudgets.controls; let i = index" [formGroupName]="i">
              <span>{{ row.get('category').value }}</span>
              <app-field [control]="row.get('amount')" [config]="{ type: 'number', inputmode: 'decimal', step: 0.01, min: 0, suffix: '€' }"></app-field>
              <ng-container *ngIf="uid">
                <span>{{ justifiedFor(row.get('category').value) | number:'1.2-2' }} €</span>
                <span>{{ row.get('amount').value > 0 ? ((justifiedFor(row.get('category').value) / row.get('amount').value * 100) | number:'1.2-2') + ' %' : '—' }}</span>
              </ng-container>
            </div>
          </div>
          <app-loading-state *ngIf="loadingJustified" [compact]="true" message="Cargando justificación…"></app-loading-state>
        </mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" class="tf-card">
        <mat-card-content>
          <div class="tf-section-header">
            <h6 class="tf-section-title">Documentación adjunta</h6>

            <div class="gf-file-actions">
              <input #fileInput class="gf-file-input" type="file" accept=".pdf,.png,.jpg,.jpeg" (change)="onFileSelected($event)">
              <button mat-stroked-button type="button" class="gf-btn" (click)="fileInput.click()" [disabled]="loadingFile">
                <mat-icon>file_upload</mat-icon> Subir archivo
              </button>
              <button mat-stroked-button type="button" class="gf-btn" (click)="pickFromFiles()" [disabled]="loadingFile">
                <mat-icon>folder</mat-icon> Desde Ficheros
              </button>
              <button *ngIf="hasFile" mat-stroked-button type="button" class="gf-btn gf-btn--danger" (click)="removeFile()" [disabled]="loadingFile">
                <mat-icon>delete</mat-icon> Quitar
              </button>
            </div>
          </div>

          <app-loading-state *ngIf="loadingFile" [compact]="true" message="Cargando documento…"></app-loading-state>

          <ng-container *ngIf="!loadingFile">
            <div class="gf-file-preview" *ngIf="hasFile && (imageUrl || pdfUrl); else noFile">
              <img *ngIf="isImage && imageUrl" [src]="imageUrl" alt="Documento de la subvención">
              <iframe *ngIf="isPdf && pdfUrl" [src]="pdfUrl" title="Documento de la subvención"></iframe>
            </div>
            <ng-template #noFile>
              <div class="gf-file-empty">
                <mat-icon>attach_file</mat-icon>
                <span>Adjunta la resolución de concesión o el justificante de cobro (PDF, PNG o JPG).</span>
              </div>
            </ng-template>
          </ng-container>
        </mat-card-content>
      </mat-card>

    </form>
  </div>

  <div class="ef-loading" *ngIf="isLoading">
    <app-loading-state [message]="uid ? 'Cargando subvención…' : 'Preparando formulario…'"></app-loading-state>
  </div>

</div>
